const support = () => {
	if (document.querySelector('.support-us form')) {
		const formEL = document.querySelector('.support-us form');

		formEL.addEventListener('submit', (event) => {
			event.preventDefault();

			const amountRadio = event.target.querySelector('input[name="amount-radio"]:checked');
			const amountManual = event.target.querySelector('input[name="amount-manual"]');
			const amount = document.querySelector('input[name="amount"]');
			const submitTarget = document.querySelector('form.is-hidden button');

			if (amountManual.value > 0) {
				amount.value = amountManual.value;
			} else {
				amount.value = amountRadio.value;
			}

			submitTarget.click();
		});
	}
};

export default support;
